var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Interfaces = OCS.Viewer.Interfaces || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Functions.define_ol_event_interface = function () {
    OCS.Viewer.Interfaces.OlEvent = {
        ol_event_keys: [],
        options: {
            change_prefix_event_string: 'change'
        },
        add_ol_event: function (event_name, callback, context, once) {
            if (!context) {
                context = this;
            }
            var ol_obj = this.get_ol_object();
            if (ol_obj) {
                if (once) {
                    return this.register_event_key(ol_obj.once(event_name, callback, context));
                } else {
                    return this.register_event_key(ol_obj.on(event_name, callback, context));
                }
            }
        },
        add_change_once_event: function (event_name, callback, context) {
            return this.add_ol_event(this.options.change_prefix_event_string + ":" + event_name, callback, context, true);
        },
        add_change_event: function (event_name, callback, context) {
            return this.add_ol_event(this.options.change_prefix_event_string + ":" + event_name, callback, context);
        },
        register_event_key: function (event) {
            this.ol_event_keys.push(event);
            return event;
        },
        remove_event: function (key) {
            var index = this.ol_event_keys.indexOf(key);
            if (index > -1) {
                this.ol_event_keys.splice(index, 1);
            }
            ol.Observable.unByKey(key);
        },
        remove_all_events: function () {
            Object.each(this.ol_event_keys, function (key) {
                ol.Observable.unByKey(key);
            }.bind(this));
            this.ol_event_keys = [];
        },
        add_change_map_selector_event: function (callback, context) {
            return this.add_change_event(this.options.map_selector_string, callback, context);
        },
        bind_property: function (target, property) {
            target.set(property, this.ol_object.get(property));
            return this.ol_object.on('change:' + property, function (e) {
                var new_val = e.target.get(e.key);
                var old_val = target.get(property);
                if (new_val !== old_val) {
                    target.set(property, new_val);
                }
            }, this);

        },
        unbind_property: function (event_key) {
            ol.Observable.unByKey(event_key);
        }
    };
};
OCS.Viewer.Functions.define_ol_event_interface();